module.exports = __webpack_public_path__ + "img/banner-news.19bd5606.jpg";